const STORAGE_KEY = 'implog_sms_templates';
const PHONES_KEY = 'implog_sender_phones';

export type SmsTemplate = {
  id: string;
  name: string;
  message: string;
  createdAt: string;
  updatedAt: string;
};

export type SenderPhone = {
  id: string;
  label: string;   // e.g. "Klinik A", "İş Hattı"
  number: string;  // e.g. "05xxxxxxxxx"
  createdAt: string;
};

// ── SMS Templates ────────────────────────────────────────────────────────────

function getAll(): SmsTemplate[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as SmsTemplate[]) : [];
  } catch {
    return [];
  }
}

function save(list: SmsTemplate[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

export const smsTemplatesDB = {
  getAll,
  insert(data: Omit<SmsTemplate, 'id' | 'createdAt' | 'updatedAt'>): SmsTemplate {
    const list = getAll();
    const now = new Date().toISOString();
    const item: SmsTemplate = {
      id: crypto.randomUUID(),
      ...data,
      createdAt: now,
      updatedAt: now,
    };
    list.push(item);
    save(list);
    return item;
  },
  update(id: string, data: Partial<Pick<SmsTemplate, 'name' | 'message'>>): void {
    const list = getAll().map((t) =>
      t.id === id ? { ...t, ...data, updatedAt: new Date().toISOString() } : t
    );
    save(list);
  },
  delete(id: string): void {
    save(getAll().filter((t) => t.id !== id));
  },
};

// ── Sender Phones ─────────────────────────────────────────────────────────────

function getAllPhones(): SenderPhone[] {
  try {
    const raw = localStorage.getItem(PHONES_KEY);
    return raw ? (JSON.parse(raw) as SenderPhone[]) : [];
  } catch {
    return [];
  }
}

function savePhones(list: SenderPhone[]): void {
  localStorage.setItem(PHONES_KEY, JSON.stringify(list));
}

export const senderPhonesDB = {
  getAll: getAllPhones,
  insert(data: Pick<SenderPhone, 'label' | 'number'>): SenderPhone {
    const list = getAllPhones();
    const item: SenderPhone = {
      id: crypto.randomUUID(),
      ...data,
      createdAt: new Date().toISOString(),
    };
    list.push(item);
    savePhones(list);
    return item;
  },
  delete(id: string): void {
    savePhones(getAllPhones().filter((p) => p.id !== id));
  },
};
